import Config from 'config';
import AbstractService from './AbstractService';

export default class ArchiveService extends AbstractService {
	static restoreRelease(releaseId) {
		return this.del(
			Config.endpoints.archiveDetail.replace('{0}', releaseId)
		);
	}

	static clear() {
		return this.del(Config.endpoints.archive);
	}
}
